import request from '@/utils/httpRequest'

export function getInspectionConclusion() {
    return request({
        url: '/app/common/getInspectionConclusion',
        method: 'get'
    })
}

export function getProblemImportant() {
    return request({
        url: '/app/common/getProblemImportant',
        method: 'get'
    })
}

export function getMajorList(data) {
    return request({
        url: '/app/common/getMajorByWorkNo/' + data,
        method: 'get'
    })
}

export function getTestItemTestType() {
    return request({
        url: '/app/common/getTestItemTestType',
        method: 'get'
    })
}

export function getSubjectDropDown(no) {
    return request({
        url: '/app/common/getSubjectDropDown/' + no,
        method: 'get'
    })
}

export function getSutConclusion() {
    return request({
        url: '/app/common/getSutConclusion',
        method: 'get'
    })
}

export function upload(path, data) {
    return request({
        url: '/app/file/upload/' + path,
        method: 'post',
        data
    })
}
